import { Comparable, ComparableResult } from './types';

export function chainComparators<TRowData>(
    comp: Comparable<TRowData>,
    ...rest: Comparable<TRowData>[]
): Comparable<TRowData> {
    return (leftItem: TRowData, rightItem: TRowData) => {
        let result = comp(leftItem, rightItem);
        let i = 0;
        while (result === ComparableResult.equal && i < rest.length) {
            result = rest[i](leftItem, rightItem);
            i++;
        }
        return result;
    };
}
